import React, { useEffect, useMemo, useState } from 'react';
import { VbzButton, VbzDivider } from '@smiles/voebiz-ui-kit';
import { useTranslation } from 'react-i18next';

import { redirectToHome } from '../../utils/redirectToHome';

import IconBeachChair from '../../assets/icons/beach-chair.svg';
import IconBrokenSuitcase from '../../assets/icons/broken-suitcase.svg';
import logoHeaderGroupVoebiz from '../../assets/header-group-logos.svg';
import logoHeaderMobileVoebiz from '../../assets/voebiz-logo-header-mobile.svg';
import logoFooterGroupVoebiz from '../../assets/footer-group-logos.svg';

export enum MessageType {
  SuccessPassword = 'success_password',
  FailurePassword = 'failure_password',
  FailureLink = 'failure_link',
  FailureGeneric = 'failure_generic',
  FailurePasswordSecurity = 'failure_password_security',
}
export interface Params {
  message?: MessageType;
}

const PasswordResponse: React.FC<Params> = ({ message = MessageType.SuccessPassword }) => {
  const { t } = useTranslation(message);
  const pathHome = useMemo(() => redirectToHome(true), []);
  const [isMobile, setIsMobile] = useState(false);
  const [imageFooter, setImageFooter] = useState('');

  window.addEventListener('resize', () => {
    if (window.innerWidth < 769) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  });

  useEffect(() => {
    if (window.innerWidth < 769) {
      setIsMobile(true);
    }
  }, [isMobile]);

  useEffect(() => {
    setImageFooter(logoFooterGroupVoebiz);
  }, []);

  function onClick() {
    if (message === MessageType.SuccessPassword || message === MessageType.FailureLink) {
      window.location.href = '/home';
    }

    if (
      message === MessageType.FailureGeneric ||
      message === MessageType.FailurePasswordSecurity ||
      message === MessageType.FailurePassword
    ) {
      window.location.reload();
    }
  }

  return (
    <>
      <div className="vbz-error-page-wrapper">
        <div className="vbz-home-header">
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <a href={pathHome}>
              <span className="vbz-logos voebiz">
                <img src={isMobile ? logoHeaderMobileVoebiz : logoHeaderGroupVoebiz} />
              </span>
            </a>
          </div>
        </div>
        <div className="another-email-message">
          {!isMobile && (
            <>
              <img
                src={message === MessageType.SuccessPassword ? IconBeachChair : IconBrokenSuitcase}
                alt="Status Logo"
              />
            </>
          )}
          <div>
            <h3>{t('title')}</h3>
            <p>
              {t('description')}
            </p>
            <VbzButton text={t('button')} onClick={onClick} />
          </div>
        </div>
        {isMobile && (
          <>
            <div className="footer-group">
              <p className="label-footer-group">Clientes VoeBiz voam com:</p>
              <img src={imageFooter}></img>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default PasswordResponse;
